module.exports = __webpack_public_path__ + "img/yakiton_drink_picture.d5892945.jpg";